import * as React from 'react';

export function CheckIcon() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" width="16" height="16" viewBox="0 0 16 16">
      <path
        fill="#0468FF"
        fillRule="evenodd"
        d="M14.733 4.68l-8.067 8.688-5.298-4.327 1.265-1.549L6.477 10l6.79-6.68 1.466 1.36z"
        clipRule="evenodd"
      />
    </svg>
  );
}
